import { api } from './apiClient';
import type { ClinicalCycle } from '../types';

export type CycleScorePayload = { indicatorId: string; score: number };

export type CreateCyclePayload = {
  date: string;
  approach: string;
  clinicalNotes: string;
  functionalImpairment: number;
  subjectiveDistress: number;
  copingResources: number;
  scores: CycleScorePayload[];
  aiInsight?: string;
  patientReport?: string;
  evolutionGuidelines?: string;
};

export type UpdateCyclePayload = Partial<CreateCyclePayload>;

/** Resposta da API: ciclo com scores */
export type CycleResponse = ClinicalCycle;

export function fetchCycles(patientId: string): Promise<CycleResponse[]> {
  return api.get<CycleResponse[]>(`/patients/${patientId}/cycles`);
}

export function fetchCycle(patientId: string, cycleId: string): Promise<CycleResponse> {
  return api.get<CycleResponse>(`/patients/${patientId}/cycles/${cycleId}`);
}

export function createCycle(patientId: string, payload: CreateCyclePayload): Promise<CycleResponse> {
  return api.post<CycleResponse>(`/patients/${patientId}/cycles`, payload);
}

export function updateCycle(
  patientId: string,
  cycleId: string,
  payload: UpdateCyclePayload
): Promise<CycleResponse> {
  return api.patch<CycleResponse>(`/patients/${patientId}/cycles/${cycleId}`, payload);
}

export function deleteCycle(patientId: string, cycleId: string): Promise<{ success: boolean }> {
  return api.delete<{ success: boolean }>(`/patients/${patientId}/cycles/${cycleId}`);
}
